import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'phone',
  standalone: true
})
export default class PhonePipe implements PipeTransform {
  public transform(value: string | null | undefined, type: 'withoutspaces' | null = null): string {
    if (!value) return '';

    if (value.trim() === '112') {
      return value;
    }

    const withoutSpaces: boolean = type === 'withoutspaces';
    value = value.replace(/\D/g, ''); // Verwijdert alle niet-numerieke tekens

    // Als het nummer begint met '00', vervang dit door '+'
    if (value.startsWith('00')) {
      value = '+' + value.slice(2);
    }

    // Als het nummer niet met '0' begint, voeg een '+' toe
    if (!value.startsWith('0') && !value.startsWith('+')) {
      value = '+' + value;
    }

    if (value.startsWith('+31')) {
      value = '0' + value.slice(3);
    }

    return withoutSpaces ? value.replace(/\s+/g, '') : value;
  }
}
